<template>
    <div class="register">
        <div class="register_main">
            <div class="register_plane">
                <div class="plane">
                    <div class="plane_1">
                        <!-- 标题 -->
                        <div class="title">
                            <!-- 大标题 -->
                            <div class="title_1">BestVpns</div>
                            <!-- 小标题 -->
                            <div class="title_2">{{ $t('login.tip') }}</div>
                        </div>
                        <!-- 用户名 -->
                        <div class="input">
                            <el-input v-model="register.name" :placeholder="$t('register.username')" />
                        </div>
                        <!-- 输入框1 -->
                        <div class="input">
                            <el-input v-model="register.email" :placeholder="$t('login.email')"></el-input>
                        </div>
                        <!-- 图片验证码 -->
                        <div class="input">
                            <div class="flex">
                                <div class="flex-3"><el-input v-model="register.img_code"
                                        :placeholder="$t('login.verification_code')" /></div>
                                <div class="flex-1"></div>
                                <div class="flex-2" @click="changeCode()"> <img :src="codeImg" alt=""></div>
                            </div>
                        </div>
                        <!-- 邮箱验证 -->
                        <div class="input">
                            <div style="display: flex;justify-content: center;align-items: center;">
                                <el-input style="width:70%" v-model="register.code"
                                    :placeholder="$t('register.email_code')" />
                                <el-button style="width:25%;margin-left: 15px;" type="primary" @click="senEmail()"
                                    :loading="loading1">
                                    {{ $t('register.send') }}
                                </el-button>
                            </div>
                            <div class="title8" v-if="register.img_code === ''">{{ $t('prompt.picture_code') }}</div>
                        </div>
                        <!-- 输入框2 -->
                        <div class="input">
                            <el-input v-model="register.pass1" type="password" show-password
                                :placeholder="$t('login.password')" />
                                <div class="title8" v-if="passRuleShow1">{{ $t('prompt.pass_rule') }}</div>
                        </div>
                        <!-- 输入框3 -->
                        <div class="input">
                            <el-input v-model="register.pass2" type="password" show-password
                                :placeholder="$t('login.password')" />
                            <div class="title8" v-if="passRuleShow2">{{ $t('prompt.pass_rule') }}</div>
                        </div>
                        <!-- 输入框4 -->
                        <!-- <div class="input">
                            <el-input v-model="register.invitation" placeholder="邀请码(选填)" />
                        </div> -->
                        <!-- 阅读条款 -->
                        <div class="input flex">
                            <el-checkbox v-model="register.check"></el-checkbox>
                            <span class="input_span" @click="jumpDoc()">
                                <el-link style="font-weight: 600;font-size: 15px;margin-left: 5px;">
                                    {{ $t('register.agree') }}
                                </el-link>
                            </span>
                        </div>
                        <!-- 注册按钮 -->
                        <div class="but_1">
                            <el-button type="primary" style="width:100%;border:0" :disabled="buDisabled" :loading="loading2"
                                @click="registerMethod()">
                                <i class="el-icon-register" />
                                {{ $t('register.register') }}
                            </el-button>
                        </div>
                    </div>
                    <div class="plane_2">
                        <!-- 小按钮 -->
                        <div class="but_2">
                            <el-button type="info" text @click="this.$router.push('/login');">{{ $t('register.return_login')
                            }}</el-button>
                        </div>
                        <div class="but_2">
                            <el-dropdown trigger="click">
                                <el-button type="primary" size="small" style="font-weight: 600;">
                                    {{ $t("header.language") }}
                                </el-button>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item @click="changelanguage('English')">English</el-dropdown-item>
                                        <!-- <el-dropdown-item @click="changelanguage('chinese')">简体中文</el-dropdown-item> -->
                                        <el-dropdown-item
                                            @click="changelanguage('Portuguese')">Portuguese</el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { registerApi, getCodeImg, endEmail } from '@/utils/api'
import { ElNotification } from 'element-plus'
import { useI18n } from 'vue-i18n'
export default {
    setup() {
        const { locale, t } = useI18n()
        let changelanguage = (lang) => {
            if (lang === 'chinese') {
                locale.value = 'zh'
                sessionStorage.setItem('lang', 'zh')
            } else if (lang === 'English') {
                locale.value = 'en'
                sessionStorage.setItem('lang', 'en')
            } else {
                locale.value = 'por'
                sessionStorage.setItem('lang', 'por')
            }

        }
        //监视属性
        return { locale, changelanguage, t }
    },
    data() {
        return {
            register: {
                email: '',
                pass1: '',
                pass2: '',
                code: '',
                img_code: '',
                img_id: '',
                invitation: '',
                check: false,
                name: ''
            },
            buDisabled: true,
            codeImg: '',
            loading2: false,
            loading1: false,
            passRuleShow1:true,
            passRuleShow2:true,
        }
    },
    methods: {
        registerMethod() {
            this.loading2 = true;
            if (this.register.name === '') {
                this.loading2 = false;
                return ElNotification({
                    title: this.t('prompt.Mistake'),
                    message: this.t('prompt.username_error'),
                    type: 'error',
                })
            }
            if (this.register.email === '') {
                this.loading2 = false;
                return ElNotification({
                    title: this.t('prompt.Mistake'),
                    message: this.t('prompt.email_err'),
                    type: 'error',
                })
            }
            const mailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})(;([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4}))*$/; //eslint-disable-line
            let isemail = mailReg.test(this.register.email);
            if (isemail === false) {
                this.loading2 = false;
                return ElNotification({
                    title: this.t('prompt.Mistake'),
                    message: this.t('prompt.email_err'),
                    type: 'error',
                })
            }
            if (this.register.pass1 === '' || this.register.pass2 === '') {
                this.loading2 = false;
                return ElNotification({
                    title: this.t('prompt.Mistake'),
                    message: this.t('prompt.password_err'),
                    type: 'error',
                })
            }
            if (this.register.pass1 !== this.register.pass2) {
                this.loading2 = false;
                return ElNotification({
                    title: this.t('prompt.Mistake'),
                    message: this.t('prompt.password_diff'),
                    type: 'error',
                })
            }
            let passReg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])\S{6,24}$/;//eslint-disable-line
            let ispass1 = passReg.test(this.register.pass1);
            if(ispass1 === false ){
                this.loading2 = false;
                return ElNotification({
                    title: this.t('prompt.Mistake'),
                    message: this.t('prompt.pass_rule_err'),
                    type: 'error',
                })
            }
            if (this.register.code === '') {
                this.loading2 = false;
                return ElNotification({
                    title: this.t('prompt.Mistake'),
                    message: this.t('prompt.email_code_err'),
                    type: 'error',
                })
            }
            let param = {
                name: this.register.name.trim(),
                email: this.register.email,
                password: this.register.pass1,
                emailCode: this.register.code
            }
            if (this.register.invitation !== '') {
                param['inviteCode'] = this.register.invitation;
            }
            registerApi(param).then(res => {
                if (res !== undefined) {
                    if (res.data.code === 0) {
                        this.loading2 = false;
                        ElNotification({
                            title: 'Success',
                            message: this.t('prompt.Registration_success'),
                            type: 'success',
                        })
                        this.$router.push('/login');
                    } else {
                        this.loading2 = false;
                        return ElNotification({
                            title: this.t('prompt.Mistake'),
                            message: res.data.msg,
                            type: 'error',
                        })
                    }
                } else {
                    this.loading2 = false;
                    return ElNotification({
                        title: 'Error',
                        message: 'Network error',
                        type: 'error',
                    })
                }
            })
        },
        // 发送邮箱验证
        senEmail() {
            this.loading1 = true;
            if (this.register.img_code === '') {
                this.loading1 = false;
                return ElNotification({
                    title: this.t('prompt.Mistake'),
                    message: this.t('prompt.picture_code'),
                    type: 'error',
                })
            }
            endEmail(
                {
                    imgId: this.register.img_id,
                    imgCode: this.register.img_code,
                    email: this.register.email
                }
            ).then(res => {
                if (res !== undefined) {
                    if (res.data.code === 0) {
                        this.loading1 = false;
                        return ElNotification({
                            title: this.t('prompt.Success'),
                            message: this.t('prompt.Sent_successfully'),
                            type: 'success',
                        })
                    } else {
                        this.loading1 = false;
                        return ElNotification({
                            title: this.t('prompt.Mistake'),
                            message: res.data.msg,
                            type: 'error',
                        })
                    }
                } else {
                    return ElNotification({
                        title: 'Error',
                        message: 'Network error',
                        type: 'error',
                    })
                }
            });
        },
        changeCode() {
            getCodeImg().then(res => {
                if (res !== undefined) {
                    if (res.data.code === 0) {
                        this.codeImg = res.data.data.imgDat;
                        this.register.img_id = res.data.data.imgId;

                    } else {
                        return ElNotification({
                            title: this.t('prompt.Mistake'),
                            message: res.data.msg,
                            type: 'error',
                        })
                    }
                } else {
                    return ElNotification({
                        title: 'Error',
                        message: 'Network error',
                        type: 'error',
                    })
                }
            })
        },
        jumpDoc() {
            const { href } = this.$router.resolve({
                path: '/showDocx',
            });
            window.open(href, "_blank");
        }
    },
    watch: {
        'register.check': function (newVal) {
            this.buDisabled = newVal !== true;
        },
        'register.pass1': function (newVal) {
            let passReg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])\S{6,24}$/;//eslint-disable-line
            let ispass1 = passReg.test(newVal);
            if(ispass1){
                this.passRuleShow1 = false;
            }else{
                this.passRuleShow1 = true;
            }
        },
        'register.pass2': function (newVal) {
            let passReg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])\S{6,24}$/;//eslint-disable-line
            let ispass2 = passReg.test(newVal);
            if(ispass2){
                this.passRuleShow2 = false;
            }else{
                this.passRuleShow2 = true;
            }
        }
    },
    created() {
        //获取图片验证码
        this.changeCode();
    }
}
</script>
<style  >
@import '../assets/css/main.css';
</style>
<style scoped lang="less">
/* 图片变成图标 */
::v-deep .el-icon-register {
    background: url('../assets/img/smail.png') center no-repeat;
    display: inline-table;
    background-size: cover;
    width: 20px;
    font-size: 10px;
    height: 20px;
    margin-right: 5px;
    color: white;
}

::v-deep .el-icon-register:before {
    content: "替";
    visibility: hidden;
}


.register {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-color: #e8eaf2;
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
}

.register_main {
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    overflow-y: auto;
}

.register_plane {
    max-width: 450px;
    width: 100%;
    margin: auto;
    background-color: white;
}

.plane {
    box-shadow: rgba(0, 0, 0, 0.05) 0 0.5rem 2rem;

}

.plane_1 {
    transition: opacity .25s ease-out;
    /* width: 100%; */
    margin: 0 auto;
    padding: 1.25rem;
    overflow-x: visible;
}

.title {
    text-align: center;
    margin-bottom: 1rem;
}

.input {
    margin-bottom: 1rem;
    height: calc(1.5em + 0.75rem + 8px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
}

.title_1 {
    font-size: 2.25rem;
    color: #343a40;
    font-weight: 700;
}

.title_2 {
    color: #6c757d !important;
    font-size: .875rem !important;
}

.plane_2 {
    color: #6c757d !important;
    background-color: #f8f9fa !important;
    padding: 1rem;
    display: flex;
    align-content: center;
    justify-content: space-between;
}

.but_1 {
    padding: 0.375rem 0.75rem;

}

/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #343a40 !important;
}

.but_2 {
    font-size: .875rem !important;
}

.input_span {
    font-size: 15px;
    font-weight: 600;
    display: flex;
    align-content: center;
    justify-content: space-between;
}
</style>